import type { IncomingShare } from '../share/incomingShare';

/**
 * Отложенная передача содержимого из системного меню «Поделиться» (стори 8.7).
 *
 * <p>Ровно та же схема и та же причина, что у {@link ./pendingProfileBridge}: содержимое
 * приходит в `App`, а показать выбор чата умеет только список чатов, и он в этот момент может
 * быть ещё не смонтирован — приложение как раз поднимается из системного меню. Хуже того,
 * человек может быть не авторизован: тогда впереди ещё и вход, а снимок терять нельзя.
 *
 * <p>Буфер один и держит одно последнее содержимое: пока не выбран чат, второй «поделиться»
 * заменяет первый — это то же самое, что человек сделал бы сам, отменив первый выбор.
 */

type Listener = (share: IncomingShare) => void;

let listener: Listener | null = null;
let pendingShare: IncomingShare | null = null;

/** Содержимое из системного меню. Если показывать выбор чата пока некому — ждёт подписчика. */
export function requestShareToChat(share: IncomingShare): void {
  if (listener) {
    listener(share);
    return;
  }
  pendingShare = share;
}

export function subscribeShareToChat(fn: Listener): () => void {
  listener = fn;
  if (pendingShare) {
    const s = pendingShare;
    pendingShare = null;
    fn(s);
  }
  return () => {
    if (listener === fn) listener = null;
  };
}
